<template>
        <!-- The snackbar -->
      <v-flex>      
      <v-snackbar :top="true"
                  :timeout='60000'
                  :color="$store.getters.getMsgType=='info'?'info':$store.getters.getMsgType=='error'?'error':'success'"
                  :multi-line=true
                  v-model=active>
        
        <v-icon dark flat class="ml-2">{{ $store.getters.getMsgType=='info'?'check_circle':$store.getters.getMsgType=='error'?'warning':'check_circle' }}</v-icon> 
        <h3 class="font-weight-light ml-3" >{{ $store.getters.getMsgText}}</h3>
        <v-btn tile large  icon @click.native=" transparency = 0 ">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-flex>
    <!-- END: snackbar -->
</template>


<script>

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  name: 'message',
  props: {
  },
  data () {
    return {
      transparency: 1
    }
  },
  methods: {
  },
  computed: {
    active: function () {
      return this.$store.getters.getMsgActive
    }
  },
  watch: {
    active: function (Visible) {
      if (Visible) {
        this.transparency = 1
        setTimeout(() => {
            this.transparency = 0
          },6000);
      }
    },
    transparency: function (Transp) {
      if (Transp===0) {
          this.$store.commit('closeMessage')
      }      
    }
   }
}

</script>


